import { render, staticRenderFns } from "./ticket_manage.vue?vue&type=template&id=18a02b03&scoped=true"
import script from "./ticket_manage.vue?vue&type=script&lang=js"
export * from "./ticket_manage.vue?vue&type=script&lang=js"
import style0 from "./ticket_manage.vue?vue&type=style&index=0&id=18a02b03&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a02b03",
  null
  
)

export default component.exports